import { render, staticRenderFns } from "./SupervisorSheetActions.vue?vue&type=template&id=518b5805&scoped=true"
import script from "./SupervisorSheetActions.vue?vue&type=script&lang=js"
export * from "./SupervisorSheetActions.vue?vue&type=script&lang=js"
import style0 from "./SupervisorSheetActions.vue?vue&type=style&index=0&id=518b5805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b5805",
  null
  
)

export default component.exports